import { render, staticRenderFns } from "./sysModuleAddMenus.vue?vue&type=template&id=4b1a417c&scoped=true&"
import script from "./sysModuleAddMenus.vue?vue&type=script&lang=js&"
export * from "./sysModuleAddMenus.vue?vue&type=script&lang=js&"
import style0 from "./sysModuleAddMenus.vue?vue&type=style&index=0&id=4b1a417c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a417c",
  null
  
)

export default component.exports